module.exports = __webpack_public_path__ + "img/bulgaria.378dea18.svg";